module.exports = __webpack_public_path__ + "static/media/light.cb6de49e.png";